import { useFormContext } from "react-hook-form";

import { ui } from "@patient-watch/ui";
import type { LooseRHFField } from "./utils/loose-rhf-field";
import { getTestId } from "./utils/getTestId";

interface Props {
    name: string;
    placeholder?: string;
    className?: string;
    label?: string;
    description?: string;
    required?: boolean;
}

const Textarea: React.FC<Props> = ({ name, placeholder, className, label, description, required = false }) => {
    const { control } = useFormContext();
    return (
        <ui.FormField
            control={control}
            name={name}
            data-cy={name}
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem>
                    {label && (
                        <ui.FormLabel>
                            {label}
                            {required && <span className="ml-0.5 text-red-500">*</span>}
                        </ui.FormLabel>
                    )}
                    {description && <ui.FormDescription>{description}</ui.FormDescription>}
                    <ui.FormControl>
                        <ui.Textarea
                            placeholder={placeholder}
                            className={className}
                            {...field}
                            data-testid={getTestId(name, "input")}
                        />
                    </ui.FormControl>
                    <ui.FormMessage />
                </ui.FormItem>
            )}
        />
    );
};

export default Textarea;
